import type { FaireProductEntity } from "../../entity_types/product";

export const p_ajbkkrgz4g: FaireProductEntity = {
  token: "p_ajbkkrgz4g",
  type: "product",
  name: "Soothing Lavender Head to Toe Wash",
  brandToken: "b_dvnws1tv58",
  brandName: "Zoey Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/4df751ebbbde3aeea4cff2fdc79d2e94cf21c8ffb3f5c95922a2bec26a0f6f32.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d43dc6b53537dbbe7f749324597ae5bfcedc8de6aa57d1a26b57c0b1a023d33c.jpeg",
    "https://cdn.faire.com/fastly/1d5d30a75b0b55b644587ba8406dd30794bbd242e9456bdcafe6192dab41b44f.png",
    "https://cdn.faire.com/fastly/079c7390ca74a9429c202a7e16cd150d501b660b644b4c612e5f46775d1271ec.jpeg",
    "https://cdn.faire.com/fastly/0441765de2fdc2b82683cfa87bf8f2f2d01156e78f0b69f395af5e8a09782c91.jpeg",
    "https://cdn.faire.com/fastly/6d7a6d343ccf7d43fbabdfb17b8b843b765688c521832cfb29297cd2fffb14c1.png",
    "https://cdn.faire.com/fastly/df8d03a6176abba18e1a472d200dda53dc71008b6036a821a6c9ecda0d34bb95.jpeg",
  ],
  priceDollars: 11.78,
  description:
    "Our 2-in-1 Soothing Lavender Head to Toe Wash is the perfect wind-down companion after a day of fun. Our baby wash and shampoo features a naturally gentle, tear-free formula with a balanced pH, natural mildness, and superior skin and hair conditioning properties.\n\n•\tAloe Based Formula\n•\tGentle pH\n•   Tear-Free\n•   Hypoallergenic\n•\tSulfate Free\n•\tLightweight and rinses clean\n•\tDesigned as a gentle baby wash and shampoo\n•\tSafe for delicate and sensitive skin\n•\tVegan & Leaping Bunny Certified Cruelty Free\n•\tProudly made in the USA",
  tags: [],
  msrpDollars: 23.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:13.348Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
